export default __webpack_public_path__ + "static/media/icons-risk-register.e2dd2680.svg";